import { render, staticRenderFns } from "./ProfilePostcodeToolTip.vue?vue&type=template&id=8c3cf5c4&"
import script from "./ProfilePostcodeToolTip.vue?vue&type=script&lang=ts&"
export * from "./ProfilePostcodeToolTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports